var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar9({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 311,
    viewBox: "0 0 311 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310.037 155.638C310.037 241.242 240.641 310.638 155.037 310.638C69.4327 310.638 0.0368652 241.242 0.0368652 155.638C0.0368652 70.0336 69.4327 0.637695 155.037 0.637695C240.641 0.637695 310.037 70.0336 310.037 155.638Z",
    fill: "#FFF9DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.037 26.6377L174.171 96.7483L230.861 51.2745L205.131 119.242L277.723 115.775L216.957 155.638L277.723 195.501L205.131 192.033L230.861 260.001L174.171 214.527L155.037 284.638L135.903 214.527L79.2126 260.001L104.943 192.033L32.3506 195.501L93.1169 155.638L32.3506 115.775L104.943 119.242L79.2126 51.2745L135.903 96.7483L155.037 26.6377Z",
    fill: "#98E1E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212.752 144.934C217.911 132.598 220.858 119.313 220.858 104.131C220.858 98.4374 217.911 94.6417 213.489 94.6417C196.54 94.6417 181.801 102.233 170.01 115.518C159.744 113.649 149.325 113.649 139.059 115.518C127.069 101.876 111.579 94.4389 95.5801 94.6417C91.1585 94.6417 88.2108 98.4374 88.2108 104.131C88.2108 119.313 91.1585 132.598 96.317 144.934C91.8954 151.576 88.2108 158.219 86 165.81C95.5801 189.533 147.165 218 154.535 218C161.904 218 213.489 189.533 223.069 165.81C220.858 158.219 217.174 151.576 212.752 144.934ZM161.904 189.533H147.165H161.904ZM154.535 218V189.533V218Z",
    fill: "#D65C02"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.535 218C147.165 218 95.5801 189.533 86 165.81C88.2108 158.219 91.8954 151.576 96.317 144.934C91.1585 132.598 88.2108 119.313 88.2108 104.131C88.2108 98.4374 91.1585 94.6417 95.5801 94.6417C111.579 94.4389 127.069 101.876 139.059 115.518C149.325 113.649 159.744 113.649 170.01 115.518C181.801 102.233 196.54 94.6417 213.489 94.6417C217.911 94.6417 220.858 98.4374 220.858 104.131C220.858 119.313 217.911 132.598 212.752 144.934C217.174 151.576 220.858 158.219 223.069 165.81C213.489 189.533 161.904 218 154.535 218ZM154.535 218V189.533M161.904 189.533H147.165",
    stroke: "black",
    strokeWidth: 14.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128 164.743L127.988 168.313L128 164.743ZM180.813 164.743L180.801 168.312L180.813 164.743Z",
    fill: "#D65C02"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128 164.743L127.988 168.313M180.813 164.743L180.801 168.312",
    stroke: "black",
    strokeWidth: 14.2798,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar9);
export default __webpack_public_path__ + "static/media/avatar9.0f30a47204add811bcd3b8975a6207c8.svg";
export { ForwardRef as ReactComponent };